import { motion } from "framer-motion";
import React from "react";

interface AnimateOnLoadProps {
  children: React.ReactNode;
}
export default function AnimateOnLoad({ children }: AnimateOnLoadProps) {
  return (
    <motion.div
      initial={{
        opacity: 0,
      }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 0.3,
      }}
      className="dashboard-container"
    >
      {children}
    </motion.div>
  );
}
